/* Favre — hero wideo.
   - wideo ładowane dopiero po `load` i tylko w wersji dla bieżącego ekranu (telefon ≠ desktop),
   - bez autoodtwarzania przy „ogranicz ruch” i „oszczędzanie danych” (plakat + przycisk ▶),
   - pauza poza ekranem i na ukrytej karcie, przycisk pauzy (WCAG 2.2.2). */
(function () {
  if (window.__favreHero) return;
  window.__favreHero = true;

  var mqMobile = window.matchMedia('(max-width: 749px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Telefon: karta Milky na filmie — co 3 s następny kolor (przenikanie w CSS). Stoi, gdy karta niewidoczna
  // (desktop/tablet = display:none, hero poza ekranem, ukryta karta przeglądarki). 2026-10-20.
  function glasMini(hero) {
    var box = hero.querySelector('[data-favre-glas-mini]');
    if (!box) return;
    var karty = box.querySelectorAll('.favre-glas__karta');
    if (karty.length < 2) return;
    var nr = 0;
    var naEkranie = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (w) { naEkranie = w[0].isIntersecting; }).observe(box);
    }
    setInterval(function () {
      if (document.hidden || !naEkranie || !box.offsetParent) return;
      var stara = karty[nr];
      stara.classList.add('is-wychodzi');
      stara.classList.remove('is-aktywna');
      setTimeout(function () { stara.classList.remove('is-wychodzi'); }, 1000);
      nr = (nr + 1) % karty.length;
      karty[nr].classList.add('is-aktywna');
    }, 3000);
  }

  function init(hero) {
    if (hero.__favreInit) return;
    hero.__favreInit = true;
    glasMini(hero);

    var video = hero.querySelector('.favre-hero__video');
    var toggle = hero.querySelector('[data-favre-toggle]');
    var scrollBtn = hero.querySelector('[data-favre-scroll]');
    var saveData = navigator.connection && navigator.connection.saveData;
    var userPaused = mqReduce.matches || saveData;
    var inView = true;
    var currentSrc = '';
    var ready = false; // true po `load` strony — wcześniej nie ruszamy pliku wideo

    // AV1 (mniejszy plik, czystszy obraz) tylko gdy urządzenie dekoduje go płynnie i sprzętowo — na słabszych
    // laptopach i starszych iPhone'ach AV1 szedłby programowo (zacinanie, bateria), wtedy zostaje H.264.
    var av1 = { mobile: false, d1440: false, d2160: false };
    var av1Zawiodl = false;
    function av1Ok(w, h, bitrate) {
      var mc = navigator.mediaCapabilities;
      if (!mc || !mc.decodingInfo) return Promise.resolve(false);
      return mc
        .decodingInfo({
          type: 'file',
          video: { contentType: 'video/mp4; codecs="av01.0.' + (w * h > 2100000 ? '12' : '08') + 'M.10"', width: w, height: h, bitrate: bitrate, framerate: 24 },
        })
        .then(function (r) { return !!(r && r.supported && r.smooth && r.powerEfficient); })
        .catch(function () { return false; });
    }
    // HEVC 10-bit (2026-11-02): sprzętowy na iPhone'ach, Makach i większości komputerów z Windows (Chrome/Edge).
    // Przy tej samej jakości co H.264 (VMAF) plik o ~połowę mniejszy - szybszy start, bez przycięć.
    var hevc = { mobile: false, d1440: false, d2160: false };
    function hevcOk(w, h, bitrate) {
      var mc = navigator.mediaCapabilities;
      if (!mc || !mc.decodingInfo) return Promise.resolve(false);
      var typ = 'video/mp4; codecs="hvc1.2.4.L' + (w * h > 2100000 ? '153' : '123') + '.B0"';
      if (!video.canPlayType || !video.canPlayType(typ)) return Promise.resolve(false);
      return mc
        .decodingInfo({ type: 'file', video: { contentType: typ, width: w, height: h, bitrate: bitrate, framerate: 24 } })
        .then(function (r) { return !!(r && r.supported && r.smooth && r.powerEfficient); })
        .catch(function () { return false; });
    }
    var av1Check = Promise.all([
      video.dataset.av1Mobile ? av1Ok(1080, 1920, 4000000) : false,
      video.dataset.av1DesktopQhd ? av1Ok(2560, 1440, 5000000) : false,
      video.dataset.av1Desktop ? av1Ok(3840, 2160, 9000000) : false,
      video.dataset.hevcMobile ? hevcOk(1080, 1920, 2200000) : false,
      video.dataset.hevcDesktopQhd ? hevcOk(2560, 1440, 3000000) : false,
      video.dataset.hevcDesktop ? hevcOk(3840, 2160, 5000000) : false,
    ]).then(function (r) {
      av1 = { mobile: r[0], d1440: r[1], d2160: r[2] };
      hevc = { mobile: r[3], d1440: r[4], d2160: r[5] };
    });

    function source() {
      var d = video.dataset;
      // po awarii AV1 na tym urządzeniu (watchdog niżej) zawsze H.264
      if (av1Zawiodl) return mqMobile.matches ? d.srcMobile : d.srcDesktop;
      // kolejność: AV1 (sprzętowo) -> HEVC (sprzętowo) -> H.264
      if (mqMobile.matches) return av1.mobile ? d.av1Mobile : hevc.mobile ? d.hevcMobile : d.srcMobile;
      // film wypełnia ekran (cover 16:9) — potrzebna szerokość w pikselach urządzenia
      var need = Math.max(window.innerWidth, window.innerHeight * 16 / 9) * (window.devicePixelRatio || 1);
      if (need > 2600) return av1.d2160 ? d.av1Desktop : hevc.d2160 ? d.hevcDesktop : d.srcDesktop;
      return av1.d1440 ? d.av1DesktopQhd : hevc.d1440 ? d.hevcDesktopQhd : d.srcDesktop;
    }

    function setLabel() {
      var paused = hero.classList.contains('is-paused');
      toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
    }

    // Płynny start (2026-11-02): film pobiera się pod plakatem i rusza, gdy zagra do końca bez przycięć.
    // Tempo mierzymy sami: r = sekundy filmu pobrane na sekundę. r >= 1,1 -> start od razu; wolniej -> czekamy na
    // zapas = długość * (1 - r) + 1 s. Gdy przeglądarka nie dociąga filmu przed startem (iOS) - start od razu jak dawniej.
    // Najpóźniej po 10 s start w każdym przypadku.
    var gotowyBezPrzerw = false;
    var startTimer = 0;
    var buforTimer = 0;
    var t0 = 0;
    var ostatniKoniec = 0;
    var ostatniPrzyrost = 0;
    var tPierwsze = 0; // chwila i stan pierwszych danych - tempo liczymy od nich (bez czasu oczekiwania na serwer)
    var koniecPierwsze = 0;
    function ruszaj() {
      if (gotowyBezPrzerw) return;
      gotowyBezPrzerw = true;
      clearTimeout(startTimer);
      clearInterval(buforTimer);
      play();
    }
    function sprawdzBufor() {
      if (gotowyBezPrzerw || !currentSrc) return;
      var teraz = performance.now();
      var b = video.buffered;
      var koniec = b && b.length ? b.end(b.length - 1) : 0;
      if (koniec > ostatniKoniec + 0.01) {
        if (!tPierwsze) { tPierwsze = teraz; koniecPierwsze = koniec; }
        ostatniKoniec = koniec;
        ostatniPrzyrost = teraz;
      }
      if (video.readyState < 3) return;
      var dl = video.duration && isFinite(video.duration) ? video.duration : 0;
      if (dl && koniec >= dl - 0.25) return ruszaj(); // cały plik pobrany
      if (teraz - ostatniPrzyrost > 1500) return ruszaj(); // przeglądarka nie buforuje przed play() (iOS)
      if (!tPierwsze) return;
      var uplynelo = (teraz - tPierwsze) / 1000;
      if (uplynelo < 0.3) return;
      var r = 0.85 * (koniec - koniecPierwsze) / uplynelo; // 15% zapasu - dane przychodzą seriami
      var zapas = r >= 1.1 ? 0 : Math.min(dl || 30, (dl || 30) * (1 - r) + 1);
      if (koniec >= zapas) ruszaj();
    }
    function load() {
      var src = source();
      if (!src || src === currentSrc) return;
      currentSrc = src;
      gotowyBezPrzerw = false;
      czekaBezKonca = false;
      clearTimeout(startTimer);
      clearInterval(buforTimer);
      hero.classList.remove('is-playing');
      t0 = ostatniPrzyrost = performance.now();
      ostatniKoniec = 0;
      tPierwsze = 0;
      koniecPierwsze = 0;
      video.preload = 'auto';
      video.src = src;
      video.load();
      buforTimer = setInterval(sprawdzBufor, 200);
      startTimer = setTimeout(ruszaj, 10000);
    }
    ['progress', 'loadeddata', 'canplay', 'canplaythrough'].forEach(function (t) {
      video.addEventListener(t, sprawdzBufor);
    });

    // WATCHDOG (2026-10-23, zgłoszenie usera: na telefonach film się nie ładował, kółko kręciło się bez końca).
    // Część urządzeń zgłasza AV1 jako płynny/sprzętowy, a w praktyce film nie rusza (albo plik się zatnie).
    // Jakość bez zmian — te same pliki: AV1 nie ruszył w 4 s / błąd → przełączenie na H.264;
    // H.264 też nie ruszył w 8 s → bez kółka, zostaje plakat, kolejna próba przy dotknięciu/przewinięciu.
    var watchdog = 0;
    var czekaBezKonca = false;
    function jestAv1(src) { return !!src && /-(av1|hevc)/.test(src); } // AV1 albo HEVC (nie H.264)
    function bezKolka() {
      clearTimeout(loaderTimer);
      hero.classList.remove('is-loading');
      var ponow = function () {
        ['touchstart', 'pointerdown', 'scroll'].forEach(function (t) { window.removeEventListener(t, ponow); });
        play();
      };
      ['touchstart', 'pointerdown', 'scroll'].forEach(function (t) {
        window.addEventListener(t, ponow, { passive: true, once: true });
      });
    }
    function naAv1Awarie() {
      if (av1Zawiodl || !jestAv1(currentSrc)) return false;
      av1Zawiodl = true;
      load();
      play();
      return true;
    }
    function pilnuj() {
      clearTimeout(watchdog);
      var av1Teraz = jestAv1(currentSrc);
      watchdog = setTimeout(function () {
        if (!video.paused && video.readyState >= 3) return; // gra
        if (hero.classList.contains('is-paused') || !inView || document.hidden) return;
        // pierwsza klatka zdekodowana, plik tylko się dociąga (wolne łącze) - to nie awaria kodeka, czekamy dalej
        if (video.readyState >= 2 && !video.error && !gotowyBezPrzerw) { pilnuj(); return; } // celowo buforujemy pod plakatem
        if (video.readyState >= 2 && !video.error && !czekaBezKonca) { czekaBezKonca = true; pilnuj(); return; }
        if (av1Teraz && naAv1Awarie()) return;
        bezKolka();
      }, av1Teraz ? 4000 : 8000);
    }
    video.addEventListener('error', function () {
      if (naAv1Awarie()) return;
      bezKolka();
    });

    function play() {
      if (!ready || userPaused || !inView || document.hidden) return;
      load();
      video.muted = true;
      if (video.paused || video.readyState < 3) pilnuj();
      if (!gotowyBezPrzerw) return; // pobiera się pod plakatem - play() z ruszaj()
      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {
          // Autoplay zablokowany (np. tryb oszczędzania energii iOS) — startujemy przy pierwszym dotknięciu,
          // przewinięciu albo kliknięciu (przycisku ▶ może nie być — jest ukrywany w ustawieniach sekcji).
          hero.classList.add('is-paused');
          hero.classList.remove('is-loading');
          setLabel();
          var odblokuj = function () {
            ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function (t) { window.removeEventListener(t, odblokuj); });
            userPaused = false;
            hero.classList.remove('is-paused');
            play();
          };
          ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function (t) {
            window.addEventListener(t, odblokuj, { passive: true, once: true });
          });
        });
      }
    }

    // ikona ładowania: dopiero gdy film każe na siebie czekać (> 0,6 s), żeby nie mignęła przy szybkim starcie
    var loaderTimer = 0;
    function czekam() {
      clearTimeout(loaderTimer);
      if (!hero.classList.contains('is-playing')) return; // przed pierwszą klatką widać plakat (2026-11-02)
      loaderTimer = setTimeout(function () {
        // film nie gra (jeszcze się ładuje albo buforuje) i nie jest celowo zatrzymany
        if (!hero.classList.contains('is-paused') && (video.readyState < 3 || video.paused)) hero.classList.add('is-loading');
      }, 600);
    }
    video.addEventListener('loadstart', czekam);
    video.addEventListener('waiting', czekam);
    video.addEventListener('stalled', czekam);

    video.addEventListener('playing', function () {
      clearTimeout(watchdog);
      clearTimeout(loaderTimer);
      hero.classList.remove('is-loading');
      hero.classList.add('is-playing');
      hero.classList.remove('is-paused');
      setLabel();
    });

    toggle.hidden = false;
    if (userPaused) hero.classList.add('is-paused');
    setLabel();

    toggle.addEventListener('click', function () {
      if (hero.classList.contains('is-paused')) {
        userPaused = false;
        hero.classList.remove('is-paused');
        play();
      } else {
        userPaused = true;
        hero.classList.add('is-paused');
        video.pause();
      }
      setLabel();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          inView = entries[0].isIntersecting;
          if (inView) play();
          else video.pause();
        },
        { threshold: 0.05 }
      ).observe(hero);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) video.pause();
      else play();
    });

    mqMobile.addEventListener('change', function () {
      if (!currentSrc) return;
      load();
      play();
    });

    if (scrollBtn) {
      scrollBtn.addEventListener('click', function () {
        var rect = hero.getBoundingClientRect();
        window.scrollTo({
          top: window.scrollY + rect.bottom,
          behavior: mqReduce.matches ? 'auto' : 'smooth',
        });
      });
    }

    // Start wideo zaraz po zbudowaniu strony. Wcześniej czekaliśmy na pełne `load` (wszystkie zdjęcia
    // produktów), co na telefonie potrafiło trwać kilkadziesiąt sekund, zanim film w ogóle zaczął się ładować.
    function start() {
      if (ready) return;
      ready = true;
      setTimeout(play, 50);
    }
    // czekamy na sprawdzenie AV1 najwyżej 1,2 s (plakat i tak już widać) — potem start z H.264;
    // spóźniony wynik przełącza na AV1 tylko, gdy film dopiero ruszył (żeby nie było widać skoku)
    av1Check.then(function () {
      if (!ready) return start();
      if (currentSrc && source() !== currentSrc && video.currentTime < 1.5) {
        load();
        play();
      }
    }, start);
    setTimeout(start, 1200);

    // Pomiary pod przezroczysty nagłówek (pasek ogłoszeń / zmiana wysokości nagłówka).
    if (hero.__favreMeasure) {
      var header = document.querySelector('.section-header');
      if (header && 'ResizeObserver' in window) new ResizeObserver(hero.__favreMeasure).observe(header);
      window.addEventListener('resize', hero.__favreMeasure);
    }
  }

  // Białe tło nagłówka już przy PIERWSZYM przewinięciu (2026-10-19). Dawn nadaje .scrolled-past-header
  // dopiero po przewinięciu o całą wysokość nagłówka (z paskiem nad menu ~100 px) — przezroczyste menu
  // wisiało wtedy jeszcze nad treścią. Klasa .favre-scrolled działa od 2 px (style w favre-hero.css).
  function naglowekPrzewiniety() {
    var h = document.querySelector('.section-header');
    if (h) h.classList.toggle('favre-scrolled', window.scrollY > 2);
  }
  window.addEventListener('scroll', naglowekPrzewiniety, { passive: true });
  naglowekPrzewiniety();

  function initAll() {
    document.querySelectorAll('[data-favre-hero]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Edytor motywu: sekcja jest przerysowywana po każdej zmianie ustawień.
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector('[data-favre-hero]');
    if (hero) init(hero);
  });
})();
